/* Bundle Builder — state machine + cart sync
   Slice 2: scaffold only. Wired up in subsequent slices.
   Pattern: one instance per .bundle-builder element on the page (usually one). */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var dl = '{' + '{';
    var dr = '}' + '}';
    return format
      .replace(dl + 'amount' + dr, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(dl + 'amount_no_decimals' + dr, Math.round(cents / 100).toString());
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'b_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function BundleBuilder(rootEl, config) {
    this.root = rootEl;
    this.config = config;
    this.state = {
      bundleId: null,
      activeTier: 1,
      activeTabIndex: 0,
      activeStyleTitle: null,
      slots: []
    };
    this.init();
  }

  BundleBuilder.prototype.init = function () {
    var self = this;

    this.refreshActiveTierMeta();

    this.rehydrateFromCart().then(function () {
      self.bindTierToggles();
      self.bindTabs();
      self.bindStyleFilter();
      self.bindAddButtons();
      self.bindDrawer();
      self.bindStickyCta();
      self.observeInfiniteScroll();
      self.render();
      self.syncAddedState();
      self.setupCardImageShimmer();
      // Server renders the root with .bb-initializing (controls dimmed +
      // inert). Release only once everything above is bound, so a dimmed
      // control is never a clickable one. rehydrateFromCart always resolves
      // (it catches fetch errors), so this cannot strand the loading state.
      self.root.classList.remove('bb-initializing');
    });
  };

  BundleBuilder.prototype.setupCardImageShimmer = function (scope) {
    qsa('.bb-card__image', scope || this.root).forEach(function (wrap) {
      if (wrap.dataset.bbShimmerBound === '1') return;
      var img = wrap.querySelector('img');
      if (!img) return;
      wrap.dataset.bbShimmerBound = '1';
      if (img.complete && img.naturalHeight > 0) return;
      wrap.classList.add('is-loading');
      var done = function () {
        wrap.classList.remove('is-loading');
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
  };

  BundleBuilder.prototype.bindStickyCta = function () {
    var self = this;
    var stickyCta = qs('[data-bb-sticky-cta]', this.root);
    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        var cta = qs('[data-bb-cta]', self.root);
        if (cta && !cta.disabled) cta.click();
      });
    }
  };

  BundleBuilder.prototype.observeInfiniteScroll = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;
    this._infiniteObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self.loadNextPage(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    this.refreshInfiniteSentinels();
  };

  BundleBuilder.prototype.refreshInfiniteSentinels = function () {
    if (!this._infiniteObserver) return;
    var self = this;
    qsa('[data-bb-grid-sentinel]', this.root).forEach(function (s) {
      if (!s.dataset.bbObserved) {
        s.dataset.bbObserved = '1';
        self._infiniteObserver.observe(s);
      }
    });
  };

  BundleBuilder.prototype.buildSkeletonCards = function (count) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var card = document.createElement('div');
      card.className = 'bb-skeleton-card';
      card.setAttribute('data-bb-skeleton', '');
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML =
        '<div class="bb-skeleton-card__image"></div>' +
        '<div class="bb-skeleton-card__line bb-skeleton-card__line--title"></div>' +
        '<div class="bb-skeleton-card__line bb-skeleton-card__line--color"></div>' +
        '<div class="bb-skeleton-card__line bb-skeleton-card__line--price"></div>' +
        '<div class="bb-skeleton-card__button"></div>';
      frag.appendChild(card);
    }
    return frag;
  };

  BundleBuilder.prototype.removeSkeletons = function (scope) {
    qsa('[data-bb-skeleton]', scope || this.root).forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  };

  BundleBuilder.prototype.loadNextPage = function (sentinel) {
    if (sentinel.dataset.bbLoading === '1') return;
    var url = sentinel.getAttribute('data-bb-next-url');
    if (!url) return;
    sentinel.dataset.bbLoading = '1';
    this._infiniteObserver.unobserve(sentinel);

    var self = this;
    var grid = qs('[data-bb-grid]', this.root);
    var currentInner = grid && qs('[data-bb-grid-inner]', grid);
    if (currentInner) {
      currentInner.appendChild(this.buildSkeletonCards(3));
    }

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=bb-grid';
    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!grid) return;
        self.removeSkeletons(grid);
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-bb-grid-inner]');
        var newSentinel = doc.querySelector('[data-bb-grid-sentinel]');
        var inner = qs('[data-bb-grid-inner]', grid);

        if (newInner && inner) {
          while (newInner.firstChild) {
            inner.appendChild(newInner.firstChild);
          }
        }
        if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
        if (newSentinel) {
          grid.appendChild(newSentinel);
        }
        self.refreshInfiniteSentinels();
        self.syncAddedState();
        self.setupCardImageShimmer(grid);
      })
      .catch(function () {
        self.removeSkeletons(grid);
        sentinel.dataset.bbLoading = '0';
      });
  };

  BundleBuilder.prototype.switchTab = function (idx) {
    if (this.state.activeTabIndex === idx) return;
    var tab = this.config.tabs[idx];
    if (!tab || !tab.collection) {
      this.state.activeTabIndex = idx;
      this.render();
      return;
    }
    this.state.activeTabIndex = idx;
    this.render();
    this.loadTab(tab.collection);
  };

  BundleBuilder.prototype.loadTab = function (collectionHandle) {
    var self = this;
    var grid = qs('[data-bb-grid]', this.root);
    if (!grid) return;

    var skeletonCount = Math.min(parseInt(this.config.pageSize, 10) || 12, 12);
    var skeletonInner = document.createElement('div');
    skeletonInner.className = 'bb-grid__inner';
    skeletonInner.setAttribute('data-bb-skeleton', '');
    skeletonInner.appendChild(this.buildSkeletonCards(skeletonCount));
    grid.textContent = '';
    grid.appendChild(skeletonInner);

    var url = '/collections/' + encodeURIComponent(collectionHandle) + '?view=bb-grid';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-bb-grid-inner]');
        var newSentinel = doc.querySelector('[data-bb-grid-sentinel]');
        var newPlaceholder = doc.querySelector('.bb-grid__empty, .bundle-builder__placeholder');

        grid.textContent = '';
        if (newInner) grid.appendChild(newInner);
        if (newSentinel) grid.appendChild(newSentinel);
        if (!newInner && newPlaceholder) grid.appendChild(newPlaceholder);

        self.rebuildStyleRowFromGrid();
        self.refreshInfiniteSentinels();
        self.syncAddedState();
        self.applyStyleFilter('');
        self.setupCardImageShimmer(grid);
      })
      .catch(function () {
        self.removeSkeletons(grid);
      });
  };

  BundleBuilder.prototype.rebuildStyleRowFromGrid = function () {
    var styleRow = qs('[data-bb-style-row]', this.root);
    if (!styleRow || !this.config.showStyleFilter) return;
    var seen = {};
    var titles = [];
    qsa('[data-bb-card]', this.root).forEach(function (card) {
      var t = card.getAttribute('data-product-title');
      if (!t || seen[t]) return;
      seen[t] = true;
      titles.push(t);
    });

    styleRow.textContent = '';
    var all = document.createElement('button');
    all.type = 'button';
    all.className = 'bb-style-pill is-active';
    all.setAttribute('data-bb-style', '');
    all.textContent = 'all';
    styleRow.appendChild(all);
    titles.forEach(function (t) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'bb-style-pill';
      pill.setAttribute('data-bb-style', t);
      pill.textContent = (t || '').toLowerCase();
      styleRow.appendChild(pill);
    });
    styleRow.hidden = titles.length === 0;
    this.bindStyleFilter();
  };

  BundleBuilder.prototype.bindStyleFilter = function () {
    var self = this;
    qsa('[data-bb-style]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-bb-style') || '';
        var locked = self.lockedStyle();
        // One style per bundle: if the user picks a different style while a
        // bundle is in progress, explain the rule before changing the filter.
        if (target && locked && target !== locked) {
          self.showStyleLockModalForStyle(target);
          return;
        }
        self.applyStyleFilter(target);
      });
    });
  };

  BundleBuilder.prototype.applyStyleFilter = function (title) {
    qsa('[data-bb-style]', this.root).forEach(function (btn) {
      var isActive = (btn.getAttribute('data-bb-style') || '') === title;
      btn.classList.toggle('is-active', isActive);
    });
    qsa('[data-bb-card]', this.root).forEach(function (card) {
      var t = card.getAttribute('data-product-title') || '';
      if (!title) {
        card.hidden = false;
      } else {
        card.hidden = t !== title;
      }
    });
  };

  BundleBuilder.prototype.bindAddButtons = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      // Style-locked cards never navigate (the image is a PDP link) —
      // any click on them explains the one-style rule instead.
      var lockedCard = e.target.closest && e.target.closest('.bb-card--style-locked');
      if (lockedCard) {
        e.preventDefault();
        self.showStyleLockModal(lockedCard);
        return;
      }
      var btn = e.target.closest && e.target.closest('[data-bb-add]');
      if (!btn) return;
      if (btn.disabled) return;
      var card = btn.closest('[data-bb-card]');
      if (!card) return;
      self.openDrawerForCard(card);
    });
  };

  BundleBuilder.prototype.openDrawerForCard = function (card) {
    var drawer = qs('[data-bb-drawer]', this.root);
    if (!drawer) return;

    var locked = this.lockedStyle();
    var cardTitle = card.getAttribute('data-product-title') || '';
    if (locked && cardTitle !== locked) {
      this.showStyleLockModal(card);
      return;
    }

    var variantsScript = qs('[data-bb-variants]', card);
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var siblings = [];
    var siblingsScript = qs('[data-bb-siblings]', card);
    if (siblingsScript) {
      try { siblings = JSON.parse(siblingsScript.textContent) || []; } catch (e) { siblings = []; }
    }

    this.drawerState = {
      card: card,
      variants: variants,
      siblings: siblings,
      productId: card.getAttribute('data-product-id') || '',
      selectedSize: null,
      selectedVariant: null,
      productTitle: card.getAttribute('data-product-title') || '',
      color: card.getAttribute('data-color') || '',
      productHandle: card.getAttribute('data-product-handle') || '',
      cardId: card.getAttribute('data-bb-card-id') || '',
      returnFocus: document.activeElement
    };

    this.renderDrawer();
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      requestAnimationFrame(function () {
        var closeBtn = qs('[data-bb-drawer-close]', drawer);
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      });
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bb-drawer-open');
  };

  BundleBuilder.prototype.closeDrawer = function () {
    var drawer = qs('[data-bb-drawer]', this.root);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bb-drawer-open');
    var self = this;
    var returnFocus = this.drawerState && this.drawerState.returnFocus;
    setTimeout(function () {
      drawer.hidden = true;
      self.drawerState = null;
      if (returnFocus && typeof returnFocus.focus === 'function') {
        try { returnFocus.focus(); } catch (e) {}
      }
    }, 200);
  };

  BundleBuilder.prototype.restoreFooter = function () {
    var drawer = qs('[data-bb-drawer]', this.root);
    var footer = qs('[data-bb-drawer-footer]', drawer);
    if (!footer) return;
    if (qs('[data-bb-drawer-atc]', footer)) return;

    footer.textContent = '';
    var row = document.createElement('div');
    row.className = 'bb-drawer__price-row';
    row.setAttribute('data-bb-drawer-price-row', '');

    var compare = document.createElement('span');
    compare.setAttribute('data-bb-drawer-price-compare', '');
    compare.className = 'bb-drawer__price-compare';

    var price = document.createElement('span');
    price.setAttribute('data-bb-drawer-price', '');
    price.className = 'bb-drawer__price';

    row.appendChild(compare);
    row.appendChild(price);
    footer.appendChild(row);

    var atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'bb-drawer__atc';
    atc.setAttribute('data-bb-drawer-atc', '');
    atc.disabled = true;
    atc.textContent = 'select size';
    footer.appendChild(atc);
  };

  BundleBuilder.prototype.renderDrawer = function () {
    var drawer = qs('[data-bb-drawer]', this.root);
    var ds = this.drawerState;
    if (!drawer || !ds) return;

    this.restoreFooter();

    var titleEl = qs('[data-bb-drawer-title]', drawer);
    var subEl = qs('[data-bb-drawer-subtitle]', drawer);
    if (titleEl) titleEl.textContent = (ds.productTitle || '').toLowerCase();
    if (subEl) subEl.textContent = (ds.color || '').toLowerCase();

    var body = qs('[data-bb-drawer-body]', drawer);
    if (!body) return;
    body.textContent = '';

    var firstImg = null;
    for (var i = 0; i < ds.variants.length; i++) {
      if (ds.variants[i].image) { firstImg = ds.variants[i].image; break; }
    }
    if (firstImg) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'bb-drawer__image-wrap';
      var img = document.createElement('img');
      img.className = 'bb-drawer__image';
      img.alt = ds.productTitle + ' ' + ds.color;
      img.src = firstImg;
      imgWrap.appendChild(img);
      body.appendChild(imgWrap);
    }

    var label = document.createElement('div');
    label.className = 'bb-drawer__label';
    label.textContent = 'size';
    body.appendChild(label);

    var pillsWrap = document.createElement('div');
    pillsWrap.className = 'bb-drawer__pills';
    var self = this;
    var seen = {};
    ds.variants.forEach(function (v) {
      var size = v.size || 'One Size';
      if (seen[size]) return;
      seen[size] = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bb-drawer__pill';
      if (!v.available) btn.classList.add('is-sold-out');
      btn.setAttribute('data-bb-size', size);
      btn.textContent = size;
      btn.addEventListener('click', function () { self.handleDrawerSizeSelect(size); });
      pillsWrap.appendChild(btn);
    });
    body.appendChild(pillsWrap);

    var atc = qs('[data-bb-drawer-atc]', drawer);
    if (atc) {
      atc.disabled = true;
      atc.textContent = 'select size';
      atc.dataset.soldOut = '';
    }
    var priceEl = qs('[data-bb-drawer-price]', drawer);
    var compareEl = qs('[data-bb-drawer-price-compare]', drawer);
    if (priceEl) priceEl.textContent = '';
    if (compareEl) compareEl.textContent = '';

    var siblings = qs('[data-bb-drawer-siblings]', drawer);
    if (siblings) { siblings.hidden = true; siblings.textContent = ''; }
  };

  BundleBuilder.prototype.handleDrawerSizeSelect = function (size) {
    var ds = this.drawerState;
    if (!ds) return;
    ds.selectedSize = size;
    var variant = null;
    for (var i = 0; i < ds.variants.length; i++) {
      if ((ds.variants[i].size || 'One Size') === size) { variant = ds.variants[i]; break; }
    }
    ds.selectedVariant = variant;

    var drawer = qs('[data-bb-drawer]', this.root);
    qsa('[data-bb-size]', drawer).forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-bb-size') === size);
    });

    var priceEl = qs('[data-bb-drawer-price]', drawer);
    var compareEl = qs('[data-bb-drawer-price-compare]', drawer);
    var atc = qs('[data-bb-drawer-atc]', drawer);

    if (!variant) {
      if (atc) { atc.disabled = true; atc.textContent = 'select size'; }
      return;
    }

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (variant.available) {
      if (atc) {
        atc.disabled = false;
        atc.textContent = 'add to bundle';
        atc.dataset.soldOut = '';
      }
      this.hideSiblingRow();
    } else {
      this.renderSoldOutFlow(variant);
    }
  };

  BundleBuilder.prototype.hideSiblingRow = function () {
    var drawer = qs('[data-bb-drawer]', this.root);
    var siblings = qs('[data-bb-drawer-siblings]', drawer);
    if (siblings) { siblings.hidden = true; siblings.textContent = ''; }
  };

  BundleBuilder.prototype.renderSoldOutFlow = function (variant) {
    var ds = this.drawerState;
    if (!ds) return;
    var drawer = qs('[data-bb-drawer]', this.root);
    var atc = qs('[data-bb-drawer-atc]', drawer);

    var matchingSiblings = [];
    (ds.siblings || []).forEach(function (sib) {
      var match = (sib.variants || []).find(function (sv) {
        return sv.size === ds.selectedSize && sv.available;
      });
      if (match) {
        matchingSiblings.push({ sibling: sib, variant: match });
      }
    });

    if (matchingSiblings.length > 0) {
      this.renderSiblingRow(matchingSiblings);
      if (atc) {
        atc.disabled = true;
        atc.textContent = 'this size is sold out';
        atc.dataset.soldOut = 'true';
      }
    } else {
      this.hideSiblingRow();
      this.renderBisFlow(variant);
    }
  };

  BundleBuilder.prototype.renderSiblingRow = function (matches) {
    var ds = this.drawerState;
    var drawer = qs('[data-bb-drawer]', this.root);
    var row = qs('[data-bb-drawer-siblings]', drawer);
    if (!row) return;

    row.textContent = '';
    row.hidden = false;

    var header = document.createElement('div');
    header.className = 'bb-drawer__sibling-header';
    header.textContent = 'this size in another colour:';
    row.appendChild(header);

    var swatchesWrap = document.createElement('div');
    swatchesWrap.className = 'bb-drawer__sibling-swatches';

    var self = this;
    matches.slice(0, 4).forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bb-drawer__sibling';
      btn.setAttribute('aria-label', 'try ' + m.sibling.color + ' in size ' + ds.selectedSize);

      if (m.sibling.image) {
        var img = document.createElement('img');
        img.className = 'bb-drawer__sibling-image';
        img.src = m.sibling.image;
        img.alt = '';
        btn.appendChild(img);
      }
      var name = document.createElement('span');
      name.className = 'bb-drawer__sibling-name';
      name.textContent = (m.sibling.color || '').toLowerCase();
      btn.appendChild(name);

      btn.addEventListener('click', function () {
        self.addSiblingVariant(m, ds);
      });

      swatchesWrap.appendChild(btn);
    });

    row.appendChild(swatchesWrap);
  };

  BundleBuilder.prototype.addSiblingVariant = function (match, originatingDs) {
    var v = match.variant;
    var sibling = match.sibling;
    if (this.state.slots.length >= this.activeTierQty) {
      this.closeDrawer();
      return;
    }
    this.addVariantToBundle({
      variantId: v.id,
      size: v.size,
      price: v.price,
      image: sibling.image,
      productTitle: originatingDs.productTitle,
      color: sibling.color,
      productHandle: originatingDs.productHandle,
      cardId: sibling.card_id || ''
    });
    this.closeDrawer();
  };

  BundleBuilder.prototype.renderBisFlow = function (variant) {
    var ds = this.drawerState;
    var drawer = qs('[data-bb-drawer]', this.root);
    var footer = qs('[data-bb-drawer-footer]', drawer);
    if (!footer) return;

    footer.textContent = '';

    var label = document.createElement('div');
    label.className = 'bb-drawer__bis-label';
    label.textContent = 'no other colour has this size — get notified when it’s back:';
    footer.appendChild(label);

    var form = document.createElement('div');
    form.className = 'bb-drawer__bis-form';

    var input = document.createElement('input');
    input.type = 'email';
    input.className = 'bb-drawer__bis-input';
    input.placeholder = 'email address';
    input.autocomplete = 'email';
    input.setAttribute('aria-label', 'email address for back-in-stock notification');

    var submit = document.createElement('button');
    submit.type = 'button';
    submit.className = 'bb-drawer__bis-submit';
    submit.textContent = 'notify me';

    var self = this;
    var submitFn = function () {
      var email = input.value.trim();
      if (!email || email.indexOf('@') === -1) return;
      submit.disabled = true;
      submit.textContent = 'submitting…';
      self.submitBis(email, variant.id, ds.productId, function (ok) {
        if (ok) {
          footer.textContent = '';
          var msg = document.createElement('div');
          msg.className = 'bb-drawer__bis-success';
          msg.textContent = 'you’re on the list. we’ll let you know.';
          footer.appendChild(msg);
          setTimeout(function () { self.closeDrawer(); }, 2200);
        } else {
          submit.disabled = false;
          submit.textContent = 'notify me';
          var existing = form.querySelector('.bb-drawer__bis-error');
          if (existing) existing.remove();
          var err = document.createElement('div');
          err.className = 'bb-drawer__bis-error';
          err.textContent = 'something went wrong — please try again.';
          form.appendChild(err);
        }
      });
    };

    submit.addEventListener('click', submitFn);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitFn();
    });

    form.appendChild(input);
    form.appendChild(submit);
    footer.appendChild(form);
    setTimeout(function () { input.focus(); }, 50);
  };

  BundleBuilder.prototype.submitBis = function (email, variantId, productId, done) {
    var body =
      'a=' + encodeURIComponent('VtiKvY') +
      '&email=' + encodeURIComponent(email) +
      '&variant=' + encodeURIComponent(variantId) +
      '&product=' + encodeURIComponent(productId) +
      '&platform=shopify';
    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    })
      .then(function (r) { done(!!r.ok); })
      .catch(function () { done(false); });
  };

  BundleBuilder.prototype.handleDrawerATC = function () {
    var ds = this.drawerState;
    if (!ds || !ds.selectedVariant) return;
    var v = ds.selectedVariant;

    if (!v.available) {
      // Slice 7 will swap this for cross-sell / BIS. For now, no-op.
      return;
    }

    if (this.state.slots.length >= this.activeTierQty) {
      this.closeDrawer();
      return;
    }

    var drawer = qs('[data-bb-drawer]', this.root);
    var atc = qs('[data-bb-drawer-atc]', drawer);
    var originalLabel = atc ? atc.textContent : '';
    if (atc) {
      atc.disabled = true;
      atc.dataset.loading = '1';
      atc.setAttribute('aria-busy', 'true');
      atc.textContent = 'adding to bundle';
    }
    // Prevent the user from changing size mid-flight
    qsa('[data-bb-size]', drawer).forEach(function (b) { b.disabled = true; });

    var self = this;
    this.addVariantToBundle({
      variantId: v.id,
      size: v.size,
      price: v.price,
      image: v.image,
      productTitle: ds.productTitle,
      color: ds.color,
      productHandle: ds.productHandle,
      cardId: ds.cardId
    }).then(function () {
      if (atc) {
        atc.dataset.loading = '';
        atc.removeAttribute('aria-busy');
        atc.textContent = originalLabel || 'add to bundle';
        atc.disabled = false;
      }
      self.closeDrawer();
    });
  };

  BundleBuilder.prototype.bindDrawer = function () {
    if (this._drawerBound) return;
    var drawer = qs('[data-bb-drawer]', this.root);
    if (!drawer) return;
    var self = this;
    this._drawerBound = true;

    drawer.addEventListener('click', function (e) {
      var closeEl = e.target.closest && e.target.closest('[data-bb-drawer-close]');
      if (closeEl) { e.preventDefault(); self.closeDrawer(); return; }
      var atc = e.target.closest && e.target.closest('[data-bb-drawer-atc]');
      if (atc && !atc.disabled) { e.preventDefault(); self.handleDrawerATC(); }
    });

    var modal = qs('[data-bb-modal]', this.root);
    this._onKeydown = function (e) {
      if (e.key !== 'Escape') return;
      if (drawer.classList.contains('is-open')) self.closeDrawer();
      else if (modal && modal.classList.contains('is-open')) self.closeModal();
    };
    document.addEventListener('keydown', this._onKeydown);
  };

  BundleBuilder.prototype.destroy = function () {
    if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
    this._drawerBound = false;
  };

  // One style per bundle: the first item added locks the bundle to that
  // product title (e.g. all Harley). Colours and sizes stay free to mix.
  BundleBuilder.prototype.lockedStyle = function () {
    var first = this.state.slots[0];
    return (first && first.productTitle) || null;
  };

  BundleBuilder.prototype.showStyleLockModal = function (card) {
    var locked = (this.lockedStyle() || '').toLowerCase();
    var attempted = (card.getAttribute('data-product-title') || '').toLowerCase();
    this.showModal({
      title: 'one style per bundle',
      body: 'your bundle is ' + locked + ' only — mix colours and sizes, not styles. to bundle ' + attempted + ' instead, start a new bundle.',
      confirmLabel: 'keep building ' + locked,
      dismissLabel: 'start over with ' + attempted,
      onConfirm: function () {},
      onDismiss: function (bb) {
        bb.clearBundle().then(function () {
          bb.openDrawerForCard(card);
        });
      }
    });
  };

  BundleBuilder.prototype.showStyleLockModalForStyle = function (style) {
    var locked = (this.lockedStyle() || '').toLowerCase();
    var attempted = (style || '').toLowerCase();
    this.showModal({
      title: 'one style per bundle',
      body: 'your bundle is ' + locked + ' only — mix colours and sizes, not styles. to bundle ' + attempted + ' instead, start a new bundle.',
      confirmLabel: 'keep building ' + locked,
      dismissLabel: 'start over with ' + attempted,
      onConfirm: function () {},
      onDismiss: function (bb) {
        bb.clearBundle().then(function () {
          bb.applyStyleFilter(style);
        });
      }
    });
  };

  BundleBuilder.prototype.clearBundle = function () {
    var self = this;
    // Sequential removals: parallel /cart/change.js calls can race each other.
    var chain = Promise.resolve();
    this.state.slots.forEach(function (slot) {
      if (!slot.lineKey) return;
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: slot.lineKey, quantity: 0 })
        });
      });
    });
    return chain.then(function () {
      self.state.slots = [];
      self.state.bundleId = uuid();
      self._tierUpgradePrompted = false;
      self.render();
      self.syncAddedState();
    });
  };

  BundleBuilder.prototype.addVariantToBundle = function (item) {
    var self = this;
    if (this.state.slots.length >= this.activeTierQty) {
      return Promise.resolve();
    }
    var locked = this.lockedStyle();
    if (locked && item.productTitle !== locked) {
      return Promise.resolve();
    }
    var body = {
      items: [{
        id: item.variantId,
        quantity: 1,
        properties: {
          Bundle: 'Perfect Bundle',
          _bundle_id: this.state.bundleId,
          _bundle_tier: String(this.state.activeTier),
          _bundle_builder: this.config.originMarker
        }
      }]
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        var addedItem = (resp.items && resp.items[0]) || resp;
        self.state.slots.push({
          variantId: item.variantId,
          productHandle: item.productHandle,
          productTitle: item.productTitle,
          color: item.color,
          size: item.size,
          price: item.price,
          image: item.image,
          lineKey: addedItem.key || addedItem.id,
          cardId: item.cardId,
          tier: self.state.activeTier
        });
        self.render();
        self.syncAddedState();
        self.flashAdded(item.cardId);
        self.maybePromptTierUpgrade();
      })
      .catch(function () {});
  };

  BundleBuilder.prototype.maybePromptTierUpgrade = function () {
    if (this.state.activeTier !== 1) return;
    if (this.config.tierCount < 2) return;
    var tier1Qty = this.config.tier1.qty;
    var tier2Qty = this.config.tier2.qty;
    var tier2Pct = this.config.tier2.discount;
    if (tier2Qty <= tier1Qty) return;
    if (this.state.slots.length !== tier1Qty) return;
    if (this._tierUpgradePrompted) return;
    this._tierUpgradePrompted = true;

    var diff = tier2Qty - tier1Qty;
    this.showModal({
      title: 'unlock ' + tier2Pct + '% off',
      body: 'add ' + diff + ' more item' + (diff === 1 ? '' : 's') + ' to your bundle for ' + tier2Pct + '% off the total.',
      confirmLabel: 'keep shopping',
      dismissLabel: 'checkout now',
      onConfirm: function (bb) {
        bb.switchTier(2);
      },
      onDismiss: function () {
        window.location.href = '/cart';
      }
    });
  };

  BundleBuilder.prototype.showModal = function (opts) {
    var modal = qs('[data-bb-modal]', this.root);
    if (!modal) return;
    var self = this;

    qs('[data-bb-modal-title]', modal).textContent = opts.title || '';
    qs('[data-bb-modal-body]', modal).textContent = opts.body || '';
    var confirm = qs('[data-bb-modal-confirm]', modal);
    var dismiss = qs('[data-bb-modal-dismiss]', modal);
    confirm.textContent = opts.confirmLabel || 'OK';
    dismiss.textContent = opts.dismissLabel || 'Cancel';

    var cleanup = function () {
      confirm.removeEventListener('click', onConfirm);
      dismiss.removeEventListener('click', onDismiss);
      modal.removeEventListener('click', onClose);
      self.closeModal();
    };
    var onConfirm = function () {
      if (opts.onConfirm) opts.onConfirm(self);
      cleanup();
    };
    var onDismiss = function () {
      if (opts.onDismiss) opts.onDismiss(self);
      cleanup();
    };
    var onClose = function (e) {
      if (e.target.closest && e.target.closest('[data-bb-modal-close]')) {
        cleanup();
      }
    };
    confirm.addEventListener('click', onConfirm);
    dismiss.addEventListener('click', onDismiss);
    modal.addEventListener('click', onClose);

    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      requestAnimationFrame(function () { confirm.focus(); });
    });
    modal.setAttribute('aria-hidden', 'false');
  };

  BundleBuilder.prototype.closeModal = function () {
    var modal = qs('[data-bb-modal]', this.root);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(function () { modal.hidden = true; }, 200);
  };

  BundleBuilder.prototype.syncAddedState = function () {
    // Grey out cards that don't match the locked style. Buttons stay clickable
    // so tapping one explains the rule via the style-lock modal.
    var locked = this.lockedStyle();
    qsa('[data-bb-card]', this.root).forEach(function (card) {
      var mismatch = !!locked && (card.getAttribute('data-product-title') || '') !== locked;
      card.classList.toggle('bb-card--style-locked', mismatch);
    });
    // Buttons stay on "add to bundle" so customers can add the same variant again.
    // Transient post-add feedback is handled by flashAdded().
    qsa('[data-bb-add]', this.root).forEach(function (btn) {
      if (btn._bbResetTimer) return; // a flash is in progress; leave it alone
      btn.classList.remove('is-added');
      if (!btn.disabled) btn.textContent = 'add to bundle';
    });
  };

  BundleBuilder.prototype.flashAdded = function (cardId) {
    if (!cardId) return;
    var btn = qs('[data-bb-add][data-bb-card-id="' + cardId + '"]', this.root);
    if (!btn) return;
    btn.classList.add('is-added');
    btn.textContent = 'added';
    if (btn._bbResetTimer) clearTimeout(btn._bbResetTimer);
    btn._bbResetTimer = setTimeout(function () {
      btn._bbResetTimer = null;
      btn.classList.remove('is-added');
      if (!btn.disabled) btn.textContent = 'add to bundle';
    }, 1500);
  };

  BundleBuilder.prototype.refreshActiveTierMeta = function () {
    // Carts rehydrated with a tier that's no longer offered fall back to tier 1.
    if (this.config.tierCount < 2 && this.state.activeTier !== 1) {
      this.state.activeTier = 1;
    }
    var t = this.state.activeTier === 2 ? this.config.tier2 : this.config.tier1;
    this.activeTierQty = t.qty;
    this.activeTierDiscount = t.discount;
  };

  BundleBuilder.prototype.rehydrateFromCart = function () {
    var self = this;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props._bundle_builder !== self.config.originMarker) return;
          var bid = props._bundle_id;
          if (!bid) return;
          if (!groups[bid]) groups[bid] = [];
          for (var q = 0; q < item.quantity; q++) {
            groups[bid].push({
              variantId: item.variant_id,
              productHandle: item.handle,
              productTitle: item.product_title,
              color: item.variant_options && item.variant_options[0],
              size: item.variant_options && item.variant_options[1],
              price: item.final_price || item.price,
              image: item.image,
              lineKey: item.key,
              tier: props._bundle_tier ? parseInt(props._bundle_tier, 10) : 1
            });
          }
        });

        var bid = Object.keys(groups).pop();
        if (bid) {
          self.state.bundleId = bid;
          self.state.slots = groups[bid];
          if (self.state.slots[0] && self.state.slots[0].tier) {
            self.state.activeTier = self.state.slots[0].tier;
            self.refreshActiveTierMeta();
          }
        } else {
          self.state.bundleId = uuid();
        }
      })
      .catch(function () {
        self.state.bundleId = uuid();
      });
  };

  BundleBuilder.prototype.bindTierToggles = function () {
    var self = this;
    qsa('[data-bb-tier]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tier = parseInt(btn.getAttribute('data-bb-tier'), 10);
        self.switchTier(tier);
      });
    });
  };

  BundleBuilder.prototype.bindTabs = function () {
    var self = this;
    qsa('[data-bb-tab]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-bb-tab'), 10);
        self.switchTab(idx);
      });
    });
  };

  BundleBuilder.prototype.switchTier = function (tier) {
    if (this.state.activeTier === tier) return;
    this.state.activeTier = tier;
    this.refreshActiveTierMeta();

    var self = this;
    var promises = (this.state.slots || []).map(function (slot) {
      if (!slot || !slot.lineKey) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: slot.lineKey,
          quantity: 1,
          properties: {
            Bundle: 'Perfect Bundle',
            _bundle_id: self.state.bundleId,
            _bundle_tier: String(tier),
            _bundle_builder: self.config.originMarker
          }
        })
      });
    });

    Promise.all(promises).then(function () {
      self.render();
    });
  };

  BundleBuilder.prototype.render = function () {
    this.renderTierToggles();
    this.renderSlots();
    this.renderTabs();
    this.renderTotal();
    this.renderCTA();
    this.renderSubtitle();
    this.renderSticky();
  };

  BundleBuilder.prototype.renderSticky = function () {
    if (!this.config.showStickyBar) return;
    var sticky = qs('[data-bb-sticky]', this.root);
    if (!sticky) return;

    var slotsContainer = qs('[data-bb-sticky-slots]', sticky);
    if (slotsContainer) {
      slotsContainer.textContent = '';
      var count = this.activeTierQty;
      var self = this;
      for (var i = 0; i < count; i++) {
        var slot = this.state.slots[i];
        var el = document.createElement('div');
        el.className = 'bb-sticky-slot';
        if (slot) {
          el.classList.add('is-filled');
          if (slot.image) {
            var img = document.createElement('img');
            img.src = slot.image;
            img.alt = '';
            el.appendChild(img);
          }
          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bb-sticky-slot__remove';
          removeBtn.setAttribute('aria-label', 'remove');
          removeBtn.textContent = '×';
          (function (idx) {
            removeBtn.addEventListener('click', function (e) {
              e.stopPropagation();
              self.removeSlot(idx);
            });
          })(i);
          el.appendChild(removeBtn);
        }
        slotsContainer.appendChild(el);
      }
    }

    var stickyCta = qs('[data-bb-sticky-cta]', sticky);
    var have = this.state.slots.length;
    var need = this.activeTierQty;
    var labels = this.config.cta;
    if (stickyCta) {
      if (have === 0) {
        stickyCta.textContent = labels.empty;
        stickyCta.disabled = true;
      } else if (have < need) {
        stickyCta.textContent = labels.partial;
        stickyCta.disabled = true;
      } else {
        stickyCta.textContent = labels.complete;
        stickyCta.disabled = false;
      }
    }

    if (!this._stickyObserver && 'IntersectionObserver' in window) {
      var panel = qs('[data-bb-panel]', this.root);
      if (panel) {
        this._stickyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var isHidden = !entry.isIntersecting;
            sticky.hidden = !isHidden;
          });
        }, { threshold: 0 });
        this._stickyObserver.observe(panel);
      }
    }
  };

  BundleBuilder.prototype.renderTierToggles = function () {
    var active = this.state.activeTier;
    qsa('[data-bb-tier]', this.root).forEach(function (btn) {
      var tier = parseInt(btn.getAttribute('data-bb-tier'), 10);
      var isActive = tier === active;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  BundleBuilder.prototype.renderSlots = function () {
    var container = qs('[data-bb-slots]', this.root);
    if (!container) return;
    var count = this.activeTierQty;
    var slots = this.state.slots.slice(0, count);
    var empty = this.config.slotEmptyText;
    var self = this;

    container.textContent = '';

    for (var i = 0; i < count; i++) {
      var slot = slots[i];
      var slotEl = document.createElement('div');
      slotEl.className = 'bundle-builder__slot';
      slotEl.setAttribute('data-bb-slot', String(i));
      slotEl.setAttribute('role', 'listitem');

      if (slot) {
        var filled = document.createElement('div');
        filled.className = 'bundle-builder__slot-filled';
        if (slot.image) {
          var img = document.createElement('img');
          img.src = slot.image;
          if (slot.productTitle) img.alt = slot.productTitle;
          filled.appendChild(img);
        }
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'bundle-builder__slot-remove';
        removeBtn.setAttribute('data-bb-remove', String(i));
        removeBtn.setAttribute('aria-label', 'Remove');
        removeBtn.textContent = '×';
        (function (idx) {
          removeBtn.addEventListener('click', function () { self.removeSlot(idx); });
        })(i);
        filled.appendChild(removeBtn);
        slotEl.appendChild(filled);
      } else {
        var emptyEl = document.createElement('div');
        emptyEl.className = 'bundle-builder__slot-empty';
        var span = document.createElement('span');
        span.textContent = empty;
        emptyEl.appendChild(span);
        slotEl.appendChild(emptyEl);
      }

      container.appendChild(slotEl);
    }
  };

  BundleBuilder.prototype.removeSlot = function (idx) {
    var slot = this.state.slots[idx];
    if (!slot || !slot.lineKey) return;
    var self = this;

    // Mark the slot in both the panel and the sticky bar so the user sees
    // immediate feedback while /cart/change.js is in flight.
    var panelSlot = qs('[data-bb-slot="' + idx + '"]', this.root);
    if (panelSlot) {
      panelSlot.classList.add('is-removing');
      panelSlot.setAttribute('aria-busy', 'true');
    }
    var stickySlots = qsa('[data-bb-sticky-slots] .bb-sticky-slot', this.root);
    var stickySlot = stickySlots[idx];
    if (stickySlot) {
      stickySlot.classList.add('is-removing');
      stickySlot.setAttribute('aria-busy', 'true');
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: slot.lineKey, quantity: 0 })
    }).then(function () {
      self.state.slots.splice(idx, 1);
      self.render();
      self.syncAddedState();
    }).catch(function () {
      // On failure leave the slot intact; clear the spinner so the user can retry.
      if (panelSlot) {
        panelSlot.classList.remove('is-removing');
        panelSlot.removeAttribute('aria-busy');
      }
      if (stickySlot) {
        stickySlot.classList.remove('is-removing');
        stickySlot.removeAttribute('aria-busy');
      }
    });
  };

  BundleBuilder.prototype.renderTabs = function () {
    var active = this.state.activeTabIndex;
    qsa('[data-bb-tab]', this.root).forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-bb-tab'), 10);
      var isActive = idx === active;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  BundleBuilder.prototype.renderTotal = function () {
    var total = qs('[data-bb-total]', this.root);
    if (!total) return;
    if (this.state.slots.length === 0) {
      total.hidden = true;
      return;
    }
    var subtotal = this.state.slots.reduce(function (s, x) { return s + (x.price || 0); }, 0);
    var qualifying = this.state.slots.length >= this.activeTierQty;
    var discountPct = qualifying ? this.activeTierDiscount : 0;
    var discounted = Math.round(subtotal * (1 - discountPct / 100));

    qs('[data-bb-total-compare]', total).textContent = discountPct > 0 ? formatMoney(subtotal) : '';
    qs('[data-bb-total-final]', total).textContent = formatMoney(discounted);
    total.hidden = false;
  };

  BundleBuilder.prototype.renderCTA = function () {
    var cta = qs('[data-bb-cta]', this.root);
    var hint = qs('[data-bb-hint]', this.root);
    if (!cta) return;

    var have = this.state.slots.length;
    var need = this.activeTierQty;
    var labels = this.config.cta;
    var self = this;

    cta.onclick = null;

    if (have === 0) {
      cta.textContent = labels.empty;
      cta.disabled = true;
      if (hint) { hint.hidden = true; hint.textContent = ''; }
    } else if (have < need) {
      cta.textContent = labels.partial;
      cta.disabled = true;
      if (hint) {
        hint.textContent = '';
        var msg = document.createElement('span');
        var lockedTitle = this.lockedStyle();
        var styleNote = lockedTitle ? ' ' + lockedTitle.toLowerCase() : '';
        msg.textContent = 'add ' + (need - have) + ' more' + styleNote + ' to unlock ' + this.activeTierDiscount + '% off';
        hint.appendChild(msg);

        // F17-a: when stuck on tier 2 but already at tier 1 qty, offer a downgrade link
        if (this.state.activeTier === 2 && this.config.tierCount === 2 && have >= this.config.tier1.qty) {
          var sep = document.createTextNode(' — ');
          hint.appendChild(sep);
          var link = document.createElement('button');
          link.type = 'button';
          link.className = 'bb-link';
          link.textContent = 'or check out with ' + this.config.tier1.qty + ' for ' + this.config.tier1.discount + '% off';
          link.addEventListener('click', function () { self.switchTier(1); });
          hint.appendChild(link);
        }
        hint.hidden = false;
      }
    } else {
      cta.textContent = labels.complete;
      cta.disabled = false;
      cta.onclick = function () {
        // Items are already in the cart (added on each slot selection).
        // Reset the local builder UI so a fresh bundle can be started, then
        // open the native cart drawer — same UX as adding a normal product.
        self.state.slots = [];
        self.state.bundleId = uuid();
        self._tierUpgradePrompted = false;
        self.render();
        self.syncAddedState();
        if (window.NativeCart && typeof window.NativeCart.open === 'function') {
          window.NativeCart.open();
        } else {
          window.location.href = '/cart';
        }
      };
      if (hint) { hint.hidden = true; hint.textContent = ''; }
    }
  };

  BundleBuilder.prototype.renderSubtitle = function () {
    var sub = qs('[data-bb-subtitle]', this.root);
    if (!sub || !this.config.subtitle.dynamic) return;
    var s = (this.config.subtitle.template || '')
      .replace('{qty}', this.activeTierQty)
      .replace('{discount}', this.activeTierDiscount);
    sub.textContent = s;
  };

  function boot() {
    qsa('[data-bundle-builder]').forEach(function (root) {
      var sectionId = root.closest('[id^="shopify-section-"]');
      var id = sectionId ? sectionId.id.replace('shopify-section-', '') : null;
      var config = id && window.BundleBuilderConfig && window.BundleBuilderConfig[id];
      if (!config) return;
      new BundleBuilder(root, config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
